var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4373 9.56282H10.6873M5.4373 5.81282H8.0623M9.6898 14.3553C12.8278 14.1476 15.3268 11.6126 15.5323 8.43032C15.572 7.80782 15.572 7.16282 15.5323 6.54032C15.3268 3.35882 12.8278 0.825318 9.6898 0.616068C8.60597 0.544644 7.51862 0.544644 6.4348 0.616068C3.2968 0.824568 0.797797 3.35882 0.592297 6.54107C0.552568 7.17044 0.552568 7.80169 0.592297 8.43107C0.667297 9.58982 1.17955 10.6631 1.7833 11.5691C2.13355 12.2028 1.90255 12.9941 1.5373 13.6863C1.2748 14.1851 1.1428 14.4341 1.24855 14.6141C1.35355 14.7941 1.5898 14.8001 2.06155 14.8113C2.9953 14.8338 3.62455 14.5698 4.12405 14.2016C4.4068 13.9923 4.54855 13.8881 4.64605 13.8761C4.74355 13.8641 4.9363 13.9436 5.3203 14.1011C5.6653 14.2436 6.06655 14.3313 6.43405 14.3561C7.5028 14.4266 8.61955 14.4266 9.69055 14.3561",
    stroke: "white",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.9ae810bafb14ec22ac6242dd7f5f8554.svg";
export { ForwardRef as ReactComponent };